<template>
  <aside class="post-autor">
    <div class="post-autor__picture">
      <img :src="author.profile_image" :alt="author.name" />
    </div>
    <div class="post-autor__content">
      <div class="post-autor__name">{{ author.name }}</div>
      <div class="post-autor__summary">{{ author.bio }}</div>
      <div class="post-autor__actions">
        <router-link to="/blog/autor/antonella" class="link link--underline link--bold">{{ $t('blog.autor.moreAboutAuthor', lang) }}</router-link>
      </div>
    </div>
  </aside>
</template>

<script>
export default {
  name: "PostAutor",
  props: {
    author: {
      type: Object,
      default: () => ({
        name: "",
        profile_image: "",
        bio: "",
        url: ""
      }),
    },
  },
  computed: {
    lang() {
      return this.$route.meta?.lang || this.$i18n.locale;
    },
  },
};
</script>

<style lang="scss" scoped></style>